import React from 'react';
import { ArcBox, ArcMenuItem, ArcOutlinedInput, ArcOutlinedSelect, ArcStack, ArcText } from '@src/core/ui';
import { FlightControlsProps } from '../../types';
import { CONTROLLER_MODE_OPTIONS, ControllerModeEnum, STICK_MAPPINGS } from '../../config/controller-constants';
import mode1Image from '../../assets/mode_1.png';
import mode2Image from '../../assets/mode_2.png';

const MODE_IMAGES: Record<ControllerModeEnum, string> = {
  [ControllerModeEnum.MODE_1]: mode1Image,
  [ControllerModeEnum.MODE_2]: mode2Image,
};

const FlightControls: React.FC<FlightControlsProps> = ({ controllerMode, onModeChange }) => {
  const mappings = STICK_MAPPINGS[controllerMode];

  const stickFields = [
    { label: 'L-Stick Up / Down', value: mappings.lStickUpDown },
    { label: 'L-Stick Left / Right', value: mappings.lStickLeftRight },
    { label: 'R-Stick Up / Down', value: mappings.rStickUpDown },
    { label: 'R-Stick Left / Right', value: mappings.rStickLeftRight },
  ];

  return (
    <ArcStack spacing={3} flex={1}>
      <ArcText.h3>Flight Controls</ArcText.h3>

      <ArcStack spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
        <ArcText.h5>Controller Mode</ArcText.h5>
        <ArcOutlinedSelect
          sx={{ width: 250 }}
          value={controllerMode}
          onChange={(e) => {
            const value = e.target.value as ControllerModeEnum;
            onModeChange(value);
          }}
        >
          {CONTROLLER_MODE_OPTIONS.map(({ value, name }) => (
            <ArcMenuItem key={value} value={value}>
              {name}
            </ArcMenuItem>
          ))}
        </ArcOutlinedSelect>
      </ArcStack>

      <ArcBox
        sx={{
          border: '1px solid',
          borderColor: 'ghost.main',
          borderRadius: 2,
          p: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={MODE_IMAGES[controllerMode]}
          alt={`Controller ${controllerMode}`}
          style={{ maxWidth: '80%', height: 'auto' }}
        />
      </ArcBox>

      <ArcStack spacing={2}>
        {stickFields.map(({ label, value }) => (
          <ArcStack key={label} spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
            <ArcText.h5>{label}</ArcText.h5>
            <ArcOutlinedInput
              value={value}
              sx={{ width: 250 }}
              slotProps={{ input: { readOnly: true } }}
            />
          </ArcStack>
        ))}
      </ArcStack>
    </ArcStack>
  );
};

export default FlightControls;
